// extracted by mini-css-extract-plugin
export default {"root":"_241JN","caption":"_2s26F","info":"_2UG0Y","labelType":"_3lw8d","labelDuration":"iFkDv"};